import auth from "@/store/getters/auth"

export default {
  ...auth,
}
